import { TTV_CONVERSION_SOUND_IDS_STORAGE_KEY } from "@/app/(application)/(normal)/create/ttvConversionSoundIds/constants";
import { readTtvConversionSoundIds } from "@/app/(application)/(normal)/create/ttvConversionSoundIds/readTtvConversionSoundIds";

export const rememberTtvConversionSoundIds = (
  soundIds: string[],
  transferId: string | null
): void => {
  const remembered = readTtvConversionSoundIds();
  soundIds.forEach((id) =>
    remembered.set(id, transferId ?? remembered.get(id) ?? null)
  );
  try {
    sessionStorage.setItem(
      TTV_CONVERSION_SOUND_IDS_STORAGE_KEY,
      JSON.stringify([...remembered])
    );
  } catch (error) {
    console.error("Could not remember the transferred take IDs", error);
  }
};
